export default {
    MOVE_OUT_REASONS: 'companies/:company_id/move-out-reasons/',
}